// extracted by mini-css-extract-plugin
module.exports = {"form-structure-stats-cell":"style_form-structure-stats-cell__YIPrL"};